import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-dropdown-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*"),
  /*#__PURE__*/_createTextVNode("Trade")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!

  return (_ctx.displayTradeList())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_q_select, {
          modelValue: _ctx.selectedTrade,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTrade) = $event)),
          options: _ctx.tradeList,
          "option-label": "name",
          "option-value": "name",
          "bottom-slots": "",
          outlined: "",
          "data-test": "trade-dropdown",
          dense: ""
        }, null, 8 /* PROPS */, ["modelValue", "options"])
      ]))
    : _createCommentVNode("v-if", true)
}